<h1 matDialogTitle>{{data.title}}</h1>
<div mat-dialog-content>
    <mat-card class="p-0">
        <form [formGroup]="doctoCCForm"  *ngIf="doctoCCForm">
            <div fxLayout="row wrap"  >
                <div fxFlex="100" class="pr-1"><br></div>
               
                <div fxFlex="50" fxFlex.gt-sm="100" fxFlex.sm="35">
                  <mat-form-field class="full-width">
                    <input matInput  name="seqEvento" type="text"
                      [formControl]="doctoCCForm?.controls['seqEvento']!" placeholder="Sequência do evento">
                  </mat-form-field>
                  <small
                    *ngIf="doctoCCForm?.controls['seqEvento']?.hasError('required') && doctoCCForm?.controls['seqEvento']?.touched"
                    class="form-error-msg"> Sequência do evento é obrigatório </small>
                </div>
                              
                <div fxFlex="100" fxFlex.gt-sm="100" fxFlex.sm="30">
                  <mat-form-field class="full-width">
                    <mat-label>Correção</mat-label>
                    <textarea matInput placeholder="Correção" name="Correção"
                      [formControl]="doctoCCForm.controls['correcao']" appearance="fill">
                    </textarea>
                    
                  </mat-form-field>
                  <small *ngIf="doctoCCForm.controls['correcao'].hasError('required') && doctoCCForm.controls['correcao'].touched"
                        class="form-error-msg"> Correção é obrigatório </small>
                </div>
                
                
            </div>
        </form>
    </mat-card>
</div>
<mat-dialog-actions>
    <div fxFlex="100" class="mt-1">
        <button class="mb-8" mat-raised-button [matTooltip]="'Salvar'" color="primary"
            (click)="this.save();$event.preventDefault();">
            <mat-icon>save</mat-icon>{{"SAVE" |
            translate }}
        </button>
        <span fxFlex></span>
        <button mat-button color="warn" type="button" (click)="close()">
            <mat-icon>close</mat-icon>{{"CLOSE" | translate }}
        </button>
    </div>
</mat-dialog-actions>